// FETCH ALL PROPERTIES FROM FABRIC_INWARD DETAILS
export const FETCH_FABRIC_INWARD_DETAILS_REQUEST_DK = 'FETCH_FABRIC_INWARD_DETAILS_REQUEST_DK';
export const FETCH_FABRIC_INWARD_DETAILS_SUCCESS_DK = 'FETCH_FABRIC_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_FABRIC_INWARD_DETAILS_FAILURE_DK = 'FETCH_FABRIC_INWARD_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM FABRIC_INWARD DETAILS
export const FETCH_FABRIC_INWARD_DETAILS_PREVIOUS_REQUEST_DK = 'FETCH_FABRIC_INWARD_DETAILS_PREVIOUS_REQUEST_DK';
export const FETCH_FABRIC_INWARD_DETAILS_PREVIOUS_SUCCESS_DK = 'FETCH_FABRIC_INWARD_DETAILS_PREVIOUS_SUCCESS_DK';
export const FETCH_FABRIC_INWARD_DETAILS_PREVIOUS_FAILURE_DK = 'FETCH_FABRIC_INWARD_DETAILS_PREVIOUS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM FABRIC_INWARD DETAILS BY ID
export const FETCH_FABRIC_INWARD_DETAILS_BY_ID_REQUEST_DK = 'FETCH_FABRIC_INWARD_DETAILS_BY_ID_REQUEST_DK';
export const FETCH_FABRIC_INWARD_DETAILS_BY_ID_SUCCESS_DK = 'FETCH_FABRIC_INWARD_DETAILS_BY_ID_SUCCESS_DK';
export const FETCH_FABRIC_INWARD_DETAILS_BY_ID_FAILURE_DK = 'FETCH_FABRIC_INWARD_DETAILS_BY_ID_FAILURE_DK';

// CREATE PROPERTIES FOR FABRIC_INWARD DETAILS
export const CREATE_FABRIC_INWARD_DETAILS_REQUEST_DK = 'CREATE_FABRIC_INWARD_DETAILS_REQUEST_DK';
export const CREATE_FABRIC_INWARD_DETAILS_SUCCESS_DK = 'CREATE_FABRIC_INWARD_DETAILS_SUCCESS_DK';
export const CREATE_FABRIC_INWARD_DETAILS_FAILURE_DK = 'CREATE_FABRIC_INWARD_DETAILS_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_FABRIC_INWARD_DETAILS_DK = 'CREATE_USER_FORM_FABRIC_INWARD_DETAILS_DK';

// UPDATE PROPERTIES FOR FABRIC_INWARD DETAILS
export const UPDATE_FABRIC_INWARD_DETAILS_REQUEST_DK = 'UPDATE_FABRIC_INWARD_DETAILS_REQUEST_DK';
export const UPDATE_FABRIC_INWARD_DETAILS_SUCCESS_DK = 'UPDATE_FABRIC_INWARD_DETAILS_SUCCESS_DK';
export const UPDATE_FABRIC_INWARD_DETAILS_FAILURE_DK = 'UPDATE_FABRIC_INWARD_DETAILS_FAILURE_DK';

// FETCH SINGLE FABRIC_INWARD_DETAILS
export const FETCH_SINGLE_FABRIC_INWARD_DETAILS_REQUEST_DK = 'FETCH_SINGLE_FABRIC_INWARD_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_FABRIC_INWARD_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_FABRIC_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_FABRIC_INWARD_DETAILS_FAILURE_DK = 'FETCH_SINGLE_FABRIC_INWARD_DETAILS_FAILURE_DK';

// DELETE PROPERTIES FOR FABRIC_INWARD DETAILS
export const DELETE_FABRIC_INWARD_DETAILS_REQUEST_DK = 'DELETE_FABRIC_INWARD_DETAILS_REQUEST_DK';
export const DELETE_FABRIC_INWARD_DETAILS_SUCCESS_DK = 'DELETE_FABRIC_INWARD_DETAILS_SUCCESS_DK';
export const DELETE_FABRIC_INWARD_DETAILS_FAILURE_DK = 'DELETE_FABRIC_INWARD_DETAILS_FAILURE_DK';

// USERFORM RESET

export const FABRIC_INWARD_DETAILS_USERFORM_RESET_DK = 'FABRIC_INWARD_DETAILS_USERFORM_RESET_DK';
export const FABRIC_INWARD_DETAILS_PO_DETAILS_DISABLED_DK = 'FABRIC_INWARD_DETAILS_PO_DETAILS_DISABLED_DK';
